import { render, staticRenderFns } from "./ActionRecordButton.vue?vue&type=template&id=4c4b6ec4&"
import script from "./ActionRecordButton.vue?vue&type=script&lang=js&"
export * from "./ActionRecordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports